import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { BodyText, Card, Icon, withStyles } from 'vopay';
import { Title, CircleButton, Button } from 'UI';
import styles from './UpgradePlanDialog.module.scss';
import { useTranslation } from 'react-i18next';

type UpgradePlanDialogProps = {
  onCancel: () => void;
};

const cn = withStyles(styles);

const UpgradePlanDialog: FC<UpgradePlanDialogProps> = ({ onCancel }) => {
  const history = useHistory();
  const { t } = useTranslation('translations', { keyPrefix: 'InteracVerification.UpgradePlanDialog' });

  return (
    <Card className={cn('modalContainer')}>
      <Title level="3">{t('title', { defaultValue: 'Upgrade Your Plan!' })}</Title>

      <div className={cn('closeButton')}>
        <CircleButton icon="close" size="large" circleFill onClick={onCancel} />
      </div>

      <BodyText className={cn('description')}>
        {t('desc', {
          defaultValue: 'Confirm ownership and registration details retrieved from Interac for this contact.',
        })}
      </BodyText>

      <div className={cn('plans')}>
        <div className={cn('plan', 'basic')}>
          <Icon icon="checkBlueGradient" width="80px" height="80px" color="none" />

          <div>
            <Title level="5">{t('Basic.title', { defaultValue: 'Basic' })}</Title>

            <BodyText className={cn('text')}>
              {t('Basic.desc', { defaultValue: 'Verify the ownership of the Interac account.' })}
            </BodyText>
          </div>
        </div>

        <div className={cn('plan', 'enhanced')}>
          <Icon icon="iconsGradient" width="80px" height="80px" color="none" />

          <div>
            <Title className={cn('title')} level="5">
              {t('Enhanced.title', { defaultValue: 'Enhanced' })}
            </Title>

            <BodyText className={cn('text')}>
              {t('Enhanced.desc', {
                defaultValue: 'Confirm ownership and access registration details retrieved from Interac.',
              })}
            </BodyText>
          </div>
        </div>
      </div>

      <Button
        className={cn('button')}
        colorScheme="primary"
        onClick={() => {
          onCancel();

          history.push({
            pathname: '/create-tickets',
            state: { ticketSubject: 'Enquiry about Interac email verification' },
          });
        }}
      >
        {t('contactButton', { defaultValue: 'Contact Support' })}
      </Button>
    </Card>
  );
};

export default UpgradePlanDialog;
